<button
  #button
  [attr.data-testid]="automationKey"
  [class.active]="active"
  [class.hover]="hover"
  [title]="tooltipText"
  (click)="onClickHandler($event)"
  >
  <div #ref><ng-content></ng-content>{{ buttonText }}</div>
  <!-- if there is projected content do not display the icon -->
  @if (!ref.children.length) {
    <i
      [ngStyle]="{ fontSize: fontSizeRem + 'rem' }"
      [class]="iconName"
    ></i>
  }
</button>
